import { LoaderCircleV2 } from 'oolib'
import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { __CheckSomeAccessToSomeModule } from '../../../utils/accessControl'
import { useGetQueryState } from '../../../utils/react-query-hooks/general'

const RouteAccessModule = ({ children, moduleId, ACTION: _ACTION, getActionFromParamsFn }) => {
  const location = useLocation()
  const params = useParams();
  const { status, data: userData } = useGetQueryState('userData')
  const ACTION = getActionFromParamsFn
    ? getActionFromParamsFn(params)
    : _ACTION


  const hasAccess = () => {
    if (!userData?.user) {
      // not logged in
      return {
        has: __CheckSomeAccessToSomeModule({
          user: undefined, 
          actions: ACTION, 
          modules: moduleId
        }),
        redirectTo: {
          pathname: '/login',
          state: {
            from: location.pathname + location.search,
          },
        },
      }
    }

    // else is logged in, and either has access to this content type or not.
    // if has, then let them through.
    // if not then simply redir back to the page they were coming from.

    

    return {
      has: __CheckSomeAccessToSomeModule({
        user:userData?.user, 
        actions:ACTION, 
        modules: moduleId
      }),
      redirectTo: '/',
    }
  }

  if (status === 'loading') {
    return <LoaderCircleV2 />
  }

  if (!hasAccess().has) {
    return <Navigate to={hasAccess().redirectTo} replace />
  }

  return children
}

export default RouteAccessModule
